import { ChangeDetectorRef, Component, OnDestroy } from "@angular/core"
import { ActivatedRoute, Params } from "@angular/router"
import { Subscription } from "rxjs/Subscription"

import { DisplayService } from "./display.service"
import { DomEventsService } from "./dom-events.service"
import { ReferralService } from "./referral-magic/referral.service"
import { SeoService } from "./seo.service"
import { ToolService } from "./tool.service"

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  providers: [DomEventsService, DisplayService, ReferralService, SeoService, ToolService]
})
export class AppComponent implements OnDestroy {
  // Local variables
  private embed_subscription: Subscription
  private modal_subscription: Subscription
  private page_background_subscription: Subscription

  background_url: string
  is_embedded = false
  is_modal = false

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private displayService: DisplayService
  ) {
    // Need to inject changeDetectorRef and call this.changeDetectorRef.detectChanges() otherwise throws error https://github.com/angular/angular/issues/17572 in console
    this.page_background_subscription = displayService.page_background_source$.subscribe((background_url) => {
      this.background_url = background_url
      this.changeDetectorRef.detectChanges()
    })

    this.modal_subscription = displayService.modal_source$.subscribe((is_modal) => {
      this.is_modal = is_modal
      this.changeDetectorRef.detectChanges()
    })

    this.embed_subscription = displayService.embed_source$.subscribe((is_embedded) => {
      this.is_embedded = is_embedded
      this.changeDetectorRef.detectChanges()
    })
  }

  close() {
    window.parent.postMessage("close-my-referral-modal", "*")
  }

  ngOnDestroy() {
    this.page_background_subscription.unsubscribe()
  }
}



// WEBPACK FOOTER //
// /home/runner/work/onelocal/onelocal/src/my-referral/src/app/app.component.ts